import { useAppStore } from '@/store/main'

export default defineNuxtRouteMiddleware((to) => {
  const store = useAppStore()
  const { homeSwitcher } = store

  to.path === '/' || to.path === '/en'
    ? homeSwitcher(true)
    : homeSwitcher(false)
})
